'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.responsibleGaming = void 0;
var tslib_1 = require("tslib");
var adapter_1 = require("../adapter");
var session_1 = require("../session/session");
var enableSelfExclusion_1 = require("../adapter/responsiblegaming/enableSelfExclusion");
var getTimeoutCategories_1 = require("../adapter/responsiblegaming/getTimeoutCategories");
var getUserTransactionLimits_1 = require("../adapter/responsiblegaming/getUserTransactionLimits");
var createUserSuspensionLimit_1 = require("../adapter/responsiblegaming/createUserSuspensionLimit");
var magic_1 = require("../magic");
var ResponsibleGaming = /** @class */ (function () {
    function ResponsibleGaming() {
    }
    /**
     * Similar to the self exclusion endpoint, gets the
     * timeout categories with their duration as 'period'
     * on each category.
     */
    ResponsibleGaming.prototype.getTimeoutCategoriesAndDurations = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, categories, periods;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this.getTimeoutCategories(),
                            this.getTimeoutDurations(),
                        ])];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 2]), categories = _a[0], periods = _a[1];
                        return [2 /*return*/, categories.map(function (category) { return (tslib_1.__assign(tslib_1.__assign({}, category), { period: periods.find(function (_a) {
                                    var id = _a.id;
                                    return category.periodDurationID === id;
                                }) })); })];
                }
            });
        });
    };
    /**
     * Gets the timeout categories
     */
    ResponsibleGaming.prototype.getTimeoutCategories = function () {
        return adapter_1.adapter.responsibleGaming.getTimeoutCategories();
    };
    /**
     * Gets the timeout durations
     */
    ResponsibleGaming.prototype.getTimeoutDurations = function () {
        return adapter_1.adapter.responsibleGaming.getTimeoutDurations();
    };
    /**
     * Enable timeout
     */
    ResponsibleGaming.prototype.enableTimeout = function (category) {
        var params = { selfExclusionCategoryId: category.id };
        return adapter_1.adapter.responsibleGaming.enableSelfExclusionCoolOff(params);
    };
    /**
     * Get self exclusion periods
     */
    ResponsibleGaming.prototype.getSelfExclusionPeriods = function () {
        return adapter_1.adapter.responsibleGaming.getSelfExclusionPeriods();
    };
    /**
     * Enable self exclusion
     */
    ResponsibleGaming.prototype.enableSelfExclusion = function (category) {
        var params = { selfExclusionCategoryId: category.id };
        return adapter_1.adapter.responsibleGaming.enableSelfExclusion(params);
    };
    /**
     * Get self exclusion url
     */
    ResponsibleGaming.prototype.getSelfExclusionURL = function () {
        return adapter_1.adapter.responsibleGaming.getSelfExclusionURL();
    };
    /**
     * Get limits
     */
    ResponsibleGaming.prototype.getLimits = function () {
        return adapter_1.adapter.responsibleGaming.getLimits();
    };
    /**
     * Enables self exclusion for all brands for one day according to the
     * Swedish regulations
     */
    ResponsibleGaming.prototype.panicSelfExcludeAllBrands = function (reason) {
        return adapter_1.adapter.responsibleGaming.enableSelfExclusion({
            selfExclusionCategoryId: getTimeoutCategories_1.TimeoutCategory.ONE_DAY,
            blockReason: reason || enableSelfExclusion_1.BlockReason.PANIC_SELF_EXCLUSION,
        });
    };
    /**
     * Enables self exclusion for the current brand only according to the
     * Swedish regulations
     */
    ResponsibleGaming.prototype.panicSelfExcludeThisBrand = function (reason) {
        return adapter_1.adapter.responsibleGaming.enableSelfExclusionCoolOff({
            selfExclusionCategoryId: getTimeoutCategories_1.TimeoutCategory.ONE_DAY,
            blockReason: reason || enableSelfExclusion_1.BlockReason.PANIC_TIMEOUT,
        });
    };
    /**
     * Enables self exclusion for 12h according to the
     * Argentinian regulations
     */
    ResponsibleGaming.prototype.lotbaPanicSelfExclusion = function () {
        return adapter_1.adapter.responsibleGaming.enableLotbaPanicSelfExclusion();
    };
    /**
     * Gets the users limits
     */
    ResponsibleGaming.prototype.getUserLimits = function (limitRemainingAmount) {
        return adapter_1.adapter.responsibleGaming.getUserLimits(limitRemainingAmount);
    };
    /**
     * Removes given user limit
     */
    ResponsibleGaming.prototype.removeLimit = function (limitId) {
        return adapter_1.adapter.responsibleGaming.removeLimit(limitId);
    };
    /**
     * Set a group of user limits
     */
    ResponsibleGaming.prototype.setUserLimits = function (limits) {
        return adapter_1.adapter.responsibleGaming.setUserLimits(limits);
    };
    /**
     * Set user limit
     */
    ResponsibleGaming.prototype.setUserLimit = function (type, duration, limitAmount, userId) {
        var user = session_1.session.getUser();
        if (!userId && !user) {
            throw new Error('User not logged in or no userId given to setUserLimit call.');
        }
        var limit = {
            type: type,
            duration: duration,
            limitAmount: limitAmount,
            userId: userId || user.userId,
        };
        return adapter_1.adapter.responsibleGaming.setUserLimits([limit]);
    };
    /**
     * Retrieves deposit limits and play statistics for the specified period.
     * @param months The amount of months to fetch for the net loss/gains
     */
    ResponsibleGaming.prototype.getUserPlayStatsAndLimits = function (months) {
        return adapter_1.adapter.responsibleGaming.getUserPlayStatsAndLimits({ months: months });
    };
    /**
     * Retrieves a list of limits that are awaiting positive user action.
     */
    ResponsibleGaming.prototype.awaitingUserLimitsConfirmation = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var limits;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, adapter_1.adapter.responsibleGaming.awaitingUserLimitConfirmation()];
                    case 1:
                        limits = _a.sent();
                        return [2 /*return*/, limits.map(function (limit) {
                                return tslib_1.__assign(tslib_1.__assign({}, limit), { 
                                    // Normalize to just ID.
                                    limitType: limit.limitType.limitType, duration: limit.duration.durationType });
                            })];
                }
            });
        });
    };
    /**
     * Confirm outstanding limits for the current user.
     */
    ResponsibleGaming.prototype.confirmUserLimits = function (payload) {
        return adapter_1.adapter.responsibleGaming.confirmUserLimits(payload);
    };
    /**
     * Get the user transaction limits for CoreX.
     */
    ResponsibleGaming.prototype.getUserTransactionLimits = function () {
        return adapter_1.adapter.responsibleGaming.getUserTransactionLimits();
    };
    /**
     * Get the max wager limits for CoreX.
     */
    ResponsibleGaming.prototype.getMaxWagerLimits = function () {
        return adapter_1.adapter.responsibleGaming.getMaxWagerLimits();
    };
    /**
     * Get the user session limits for CoreX.
     */
    ResponsibleGaming.prototype.getAllUserCumulativeSessionLimits = function () {
        return adapter_1.adapter.responsibleGaming.getAllUserCumulativeSessionLimits();
    };
    ResponsibleGaming.prototype.createUserSuspensionLimit = function (duration) {
        var user = magic_1.magic.session.getUser();
        var params = {
            createdBy: user === null || user === void 0 ? void 0 : user.id,
            intent: 'Timeout',
            duration: duration,
            cancelledBy: user === null || user === void 0 ? void 0 : user.id,
        };
        return adapter_1.adapter.responsibleGaming.createUserSuspensionLimit(params);
    };
    ResponsibleGaming.prototype.createUserSuspensionLimitSelfExclude = function (duration) {
        var user = magic_1.magic.session.getUser();
        var params = {
            createdBy: user === null || user === void 0 ? void 0 : user.id,
            intent: 'Selfexclusion',
            duration: duration !== createUserSuspensionLimit_1.CoreXSelfExcludeDuration.INDEFINITELY
                ? duration
                : null,
            cancelledBy: user === null || user === void 0 ? void 0 : user.id,
        };
        return adapter_1.adapter.responsibleGaming.createUserSuspensionLimitSelfExclude(params);
    };
    /**
     * Set the user session limits for CoreX.
     */
    ResponsibleGaming.prototype.createUserCumulativeSessionLimit = function (duration) {
        var user = magic_1.magic.session.getUser();
        var params = {
            createdBy: user === null || user === void 0 ? void 0 : user.id,
            period: getUserTransactionLimits_1.CoreXLimitDuration.ONE_DAY,
            duration: duration,
            sessionContextType: 'login',
            cancelledBy: user === null || user === void 0 ? void 0 : user.id,
        };
        return adapter_1.adapter.responsibleGaming.createUserCumulativeSessionLimit(params);
    };
    /**
     * Set the user transaction limits for CoreX.
     */
    ResponsibleGaming.prototype.createUserTransactionLimit = function (type, period, currencyCode, amount, mediatorType) {
        var user = magic_1.magic.session.getUser();
        var params = {
            createdBy: user === null || user === void 0 ? void 0 : user.id,
            type: type,
            period: period,
            currencyCode: currencyCode,
            amount: amount,
            mediatorType: mediatorType,
            cancelledBy: user === null || user === void 0 ? void 0 : user.id,
        };
        return adapter_1.adapter.responsibleGaming.createUserTransactionLimit(params);
    };
    ResponsibleGaming.prototype.cancelUserTransactionLimit = function (limitId) {
        var params = {
            id: limitId,
        };
        return adapter_1.adapter.responsibleGaming.cancelUserTransactionLimit(params);
    };
    /**
     * Set the user max wager limit for CoreX.
     */
    ResponsibleGaming.prototype.createUserWagerLimit = function (currencyCode, amount, mediatorType) {
        var user = magic_1.magic.session.getUser();
        var params = {
            createdBy: user === null || user === void 0 ? void 0 : user.id,
            currencyCode: currencyCode,
            amount: amount,
            mediatorType: mediatorType,
            cancelledBy: user === null || user === void 0 ? void 0 : user.id,
        };
        return adapter_1.adapter.responsibleGaming.createUserWagerLimit(params);
    };
    ResponsibleGaming.prototype.reviewTransactionLimit = function (params) {
        return adapter_1.adapter.responsibleGaming.reviewTransactionLimit(params);
    };
    ResponsibleGaming.prototype.reviewMaxWagerLimit = function (params) {
        return adapter_1.adapter.responsibleGaming.reviewMaxWagerLimit(params);
    };
    ResponsibleGaming.prototype.reviewCumulativeSessionLimit = function (params) {
        return adapter_1.adapter.responsibleGaming.reviewCumulativeSessionLimit(params);
    };
    ResponsibleGaming.prototype.getUserRestrictions = function (params) {
        return adapter_1.adapter.responsibleGaming.getUserRestrictions(params);
    };
    return ResponsibleGaming;
}());
exports.responsibleGaming = new ResponsibleGaming();
